import React from "react";
import { NavLink } from "react-router-dom";
import Info from "../../Shared/Svgs/Info";

const ProfileActions = () => {
    return (
        <NavLink
            to="/profile"
            className={({ isActive }) =>
                isActive
                    ? "profileLink navLink active"
                    : "profileLink navLink"
            }
        >
            <div className="ProfileActions">
                <img
                    src="/images/jane-doe.jpg"
                    className="profileImg"
                    alt="logo"
                />

                <div className="profileInfo">
                    <b>Jennier Dobes</b>
                    <div className="companyInfoContainer">
                        <img
                            src="/images/dentons-logo.png"
                            className="companyLogo"
                            alt="logo"
                        />
                        <Info />
                    </div>
                </div>
            </div>
        </NavLink>
    );
};

export default ProfileActions;
